import React, { Component } from 'react';
import Radium from 'radium';
import './scrollbar.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { createSelector } from 'reselect';
import { bool, any, shape, string, arrayOf } from 'prop-types';
import { isMobile } from '@widergy/web-utils/lib/browser';
import { isEmpty } from '@widergy/web-utils/lib/array';
import { AlertHandler } from '@widergy/energy-ui';
import IconButton from '@material-ui/core/IconButton';
import DrawerIcon from '@material-ui/icons/Dehaze';

import UserFormCreator from 'app/components/UserFormCreator';
import { ROUTES } from 'constants/routes';
import { message } from 'utils/stringUtils';
import { actionCreators as userFormActions } from 'redux/userFormHandlers';
import { accountPropTypes } from 'redux/accountHandlers';
import { appConfig } from 'config/customization';
import Images from 'config/assets';
import { CLAIM, PROCEDURE } from 'constants/userForms';
import { MobileBreakpoint } from 'constants/deviceSizes';
import { isPublicSelector } from 'redux/auth/selector';

import SidebarCloseButton from './components/SidebarCloseButton';
import SidebarButton from './components/SidebarButton';
import getSidebarOptions, {
  mobileOptions,
  NEW_CLAIM,
  CREATE_FORM,
  NEW_PROCEDURE,
  TECHNICAL_SERVICE_OPTION,
  CUSTOMER_SUPPORT_OPTION,
  INVOICES_PAYMENTS_OPTION
} from './options';
import styles from './styles';
import stylesSCSS from './styles.module.scss';

class Sidebar extends Component {
  typesAndActions = [
    {
      type: NEW_CLAIM,
      action: () => this.handleOpenClaim()
    },
    {
      type: NEW_PROCEDURE,
      action: () => this.handleOpenProcedure()
    },
    {
      type: CREATE_FORM,
      action: id => this.handleClaimSelected(id)
    }
  ];

  constructor(props) {
    super(props);
    this.state = {
      sidebarIsOpen: false,
      openedOption: null,
      optionChanged: false,
      mobileOptions: isMobile(MobileBreakpoint) && !this.props.isPublic ? mobileOptions : []
    };
    props.history.listen(location => {
      this.handleChangeRoute(location);
    });
    this.openButton = React.createRef();
    this.buttonsRef = {};
  }

  componentWillMount() {
    window.addEventListener('click', this.handleOutsideClick);
    window.addEventListener('resize', this.updateOptions);
  }

  componentDidMount = () => {
    if (this.props.isPublic) {
      this.props.dispatch(userFormActions.getPublicFormCategories(PROCEDURE));
      this.props.dispatch(userFormActions.getPublicFormCategories(CLAIM));
    }
  };

  componentWillUnmount() {
    window.removeEventListener('click', this.handleOutsideClick);
    window.removeEventListener('resize', this.updateOptions);
  }

  withoutAccountsHandler = () => AlertHandler.info(message('AccountStatus:noAccounts'));

  updateOptions = () =>
    this.setState({
      mobileOptions: isMobile(MobileBreakpoint) && !this.props.isPublic ? mobileOptions : []
    });

  handleOnPress = () => this.setState({ sidebarIsOpen: !this.state.sidebarIsOpen });

  handleChangeRoute = location => {
    this.setState({ optionChanged: true });
    if (!this.verifyOption(location.pathname)) this.setState({ openedOption: null });
  };

  handleOpenClaim = () => {
    if (this.props.currentAccount && this.props.currentAccount.claims_enabled === false)
      AlertHandler.error(message('AccountStatus:claimsRestricted'));
    else {
      if (this.props.isPublic) {
        this.props.dispatch(userFormActions.getPublicFormCategories(CLAIM));
      } else {
        this.props.dispatch(userFormActions.getFormCategories(CLAIM));
      }
      this.setState({ showClaim: true });
    }
  };

  handleOpenProcedure = async () => {
    if (this.props.isPublic) {
      await this.props.dispatch(userFormActions.getPublicFormCategories(PROCEDURE));
    } else {
      await this.props.dispatch(userFormActions.getFormCategories(PROCEDURE));
    }
    this.setState({ showProcedure: true });
  };

  handleFormModalClose = () => this.setState({ showClaim: false, showProcedure: false });

  handleClaimSelected = formId => {
    this.props.dispatch(userFormActions.createForm(formId, CLAIM, ROUTES.NEW_FORM));
    this.handleFormModalClose();
  };

  handleProcedureSelected = formId => {
    this.props.dispatch(userFormActions.createForm(formId, PROCEDURE, ROUTES.NEW_FORM));
    this.handleFormModalClose();
  };

  // eslint-disable-next-line consistent-return
  handleOptionClick = option => {
    if (option.key === NEW_CLAIM)
      return !this.props.loggedWithAccounts ? this.withoutAccountsHandler() : this.handleOpenClaim();
    if (option.key === NEW_PROCEDURE)
      return !this.props.loggedWithAccounts ? this.withoutAccountsHandler() : this.handleOpenProcedure();
    this.setState({ openedOption: this.state.openedOption !== option.id && option.id });
  };

  handleSuboptionClick = option => {
    // eslint-disable-next-line consistent-return
    this.typesAndActions.forEach(elem => {
      if (option.key === elem.type) {
        if (!this.props.loggedWithAccounts) {
          return this.withoutAccountsHandler();
        }
        elem.action(option.id);
      }
    });
  };

  verifyOption = path => {
    for (let index = 0; index < this.props.options.length; index += 1) {
      if (this.props.options[index].linkTo === path) return true;
      if (this.props.options[index].options) {
        for (let subIndex = 0; subIndex < this.props.options[index].options.length; subIndex += 1) {
          if (this.props.options[index].options[subIndex].linkTo === path) return true;
        }
      }
    }
    return false;
  };

  handleOutsideClick = ev => {
    if (!this.state.sidebarIsOpen) return;
    if (
      !(ev.target.id === 'openButton') &&
      !(ev.target.parentNode && ev.target.parentNode.id === 'openButton') &&
      !ev.target.contains(this.sidebar) &&
      !(
        this.buttonsRef[CUSTOMER_SUPPORT_OPTION] &&
        this.buttonsRef[CUSTOMER_SUPPORT_OPTION].contains(ev.target)
      ) &&
      !(
        this.buttonsRef[TECHNICAL_SERVICE_OPTION] &&
        this.buttonsRef[TECHNICAL_SERVICE_OPTION].contains(ev.target)
      ) &&
      !(
        this.buttonsRef[INVOICES_PAYMENTS_OPTION] &&
        this.buttonsRef[INVOICES_PAYMENTS_OPTION].contains(ev.target)
      )
    ) {
      this.setState({ sidebarIsOpen: false });
    }
  };

  refSetter = optionName => ref => (this.buttonsRef = { ...this.buttonsRef, [optionName]: ref });

  render() {
    const { options, location } = this.props;
    return (
      <div>
        <IconButton onClick={this.handleOnPress} className={stylesSCSS.drawerButton} id="openButton">
          <DrawerIcon id="openButton" />
        </IconButton>

        <div
          className={`${stylesSCSS.container} ${this.state.sidebarIsOpen ? stylesSCSS.containerActive : ''}`}
          ref={sidebar => (this.sidebar = sidebar)}
        >
          <PerfectScrollbar>
            <div>
              <SidebarCloseButton onClick={this.handleOnPress}>
                {appConfig.mobileSidebarLogo ? (
                  <img src={Images.topbarLogo} style={styles.utilityLogo} alt="logo" />
                ) : (
                  appConfig.appTitle
                )}
              </SidebarCloseButton>
              {options.concat(this.state.mobileOptions).map(option => (
                <SidebarButton
                  isActive={option.isActive}
                  optionImage={option.asset}
                  linkTo={option.linkTo}
                  externalLink={option.externalLink}
                  onOpenProcedure={this.handleOpenProcedure}
                  onOpenClaim={this.handleOpenClaim}
                  isOpen={this.state.openedOption === option.id}
                  optionChanged={this.state.optionChanged}
                  options={option.options}
                  onClick={() => this.handleOptionClick(option)}
                  onSuboptionClick={this.handleSuboptionClick}
                  currentPath={location.pathname}
                  key={option.optionName}
                  detail={option.detail}
                  refSetter={this.refSetter(option.optionName)}
                >
                  {option.optionName}
                </SidebarButton>
              ))}
            </div>
            {this.state.showClaim && (
              <UserFormCreator
                handleFormSelected={this.handleClaimSelected}
                modalOpened
                hideCreateButton
                formType={CLAIM}
                onModalClose={this.handleFormModalClose}
              />
            )}
            {this.state.showProcedure && (
              <UserFormCreator
                handleFormSelected={this.handleProcedureSelected}
                modalOpened
                hideCreateButton
                formType={PROCEDURE}
                onModalClose={this.handleFormModalClose}
              />
            )}
            <div style={styles.utilityLinks}>
              {appConfig.utilityLinks.map(link => (
                <a
                  key={link.text}
                  href={link.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={styles.link}
                >
                  {link.text.toUpperCase()}
                </a>
              ))}
            </div>
            {appConfig.useChatbot && (
              <div style={styles.chatbox}>
                <img
                  alt={message('Sidebar:chatbox')}
                  src={Images.sidebarChatbot}
                  style={styles.chatboxImage}
                />
              </div>
            )}
          </PerfectScrollbar>
        </div>
      </div>
    );
  }
}

Sidebar.propTypes = {
  history: any, // eslint-disable-line react/forbid-prop-types
  location: shape({
    pathname: string.isRequired
  }).isRequired,
  options: arrayOf(any),
  isPublic: bool,
  currentAccount: accountPropTypes,
  loggedWithAccounts: bool
};

const locationSelector = (_, props) => props.location;

const optionsSelector = createSelector(
  store => store.account.currentAccount,
  store => isPublicSelector(store),
  locationSelector,
  store => store.userForm.claimFormCategories,
  (currentAccount, isPublic, location, claimCategories) =>
    getSidebarOptions(currentAccount, isPublic, location.pathname, claimCategories)
);

const loggedWithAccountsSelector = createSelector(
  store => store.account.accounts,
  store => isPublicSelector(store),
  (accounts, isPublic) => !isEmpty(accounts) || isPublic
);

const mapStateToProps = (store, ownProps) => ({
  options: optionsSelector(store, ownProps),
  currentAccount: store.account.currentAccount,
  isPublic: isPublicSelector(store),
  loggedWithAccounts: loggedWithAccountsSelector(store)
});

export default connect(mapStateToProps)(withRouter(Radium(Sidebar)));
